import { BlocksFieldNote } from 'blocks-nextjs/blocks-web-components/components/field-note/field-note';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatFieldNote = createComponent({ react: React, tagName: 'cat-field-note', elementClass: BlocksFieldNote });
